export default __webpack_public_path__ + "static/media/Tropical_BG_img.f8ec752e.webp";